import config from '@/config'
import { device } from '@/utils/device.js'
export function formatDate(time, fmt = "yyyy-MM-dd hh:mm") {
  if(!time) {
    return ""
  }
  let date = new Date(time)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length)
      );
    }
  }
  return fmt;
}

export function formatSeconds(second) {
  var hh = parseInt(second / 3600)
  if (hh < 10) hh = '0' + hh
  var mm = parseInt((second - hh * 3600) / 60)
  if (mm < 10) mm = '0' + mm
  var ss = parseInt((second - hh * 3600) % 60)
  if (ss < 10) ss = '0' + ss
  var result = hh + ':' + mm + ':' + ss

  if (second >= 0) {
    return result
  } else {
    return 'NaN'
  }
}

// 字数统计
export function wordCount(content) {
  let sLen = 0;
  let str = String(content);
  try {
    str = str.replace(/<[^>]+>/g, "");
    // 先将回车换行符做特殊处理
    str = str.replace(/(\r\n+|\s+)/g, "龘");
    // 处理英文字符数字，连续字母、数字、英文符号视为一个单词
    str = str.replace(/[\x00-\xff]/g, "m");
    // 合并字符m，连续字母、数字、英文符号视为一个单词
    str = str.replace(/m+/g, "*");
    // 去掉回车换行符
    str = str.replace(/龘+/g, "");
    // 返回字数
    sLen = str.length;
  } catch (e) {
    sLen = 0;
  }
  return sLen;
}

export const buildResourcePath = (src) => {
  if (!src) {
    return ''
  }
  var httpReg = /^(http|https)/;
  if (httpReg.test(src)) {
    src = src.replace("https://leicloud.ulearning.cn", config.RESOURCE_SERVER_HOST);
    src = src.replace("http://leicloud.qiniudn.com", config.RESOURCE_SERVER_HOST);
  } else {
    src = config.RESOURCE_SERVER_HOST + "/" + src;
  }
  return src;
}

export function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

export function getHtmlText(content) {
  if (content) {
    var temp = document.createElement("div");
    temp.innerHTML = content;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output.substring(0, 200);
  } else {
    return "";
  }
}

export function buildUrlProtocol (url) {
  var httpReg = /^(http|https)/
  if (!httpReg.test(url)) {
    url = 'https://' + url
  }
  return url
}

export function wxLogin() {
  let redirect_uri = encodeURIComponent(`https://www${config.UMOOC_COOKIE_DOMAIN}/r/wx.html`)
  if (!device.isMobile) {
    window.location.href =
      "https://open.weixin.qq.com/connect/qrconnect?lang=zh_CN" +
      "&appid=" +
      config.WXPCLOGINAPPID +
      "&redirect_uri=" +
      redirect_uri +
      "&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect";
  }

  if (device.platform.weixin) {
    let url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      config.WXGZHAPPID +
      "&redirect_uri=" +
      redirect_uri +
      "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect"
    window.location.href = url
  }
}

export function welinkLogin() {
  window.location.href =
    "index.html#/welinkCode?isLogin=1";
}